module.exports = __webpack_public_path__ + "static/course2-b3045ddb403d005ebd09d765fdb0747c.jpg";